import { render, staticRenderFns } from "./pos_sync_feed.vue?vue&type=template&id=076136b4&scoped=true&"
import script from "./pos_sync_feed.vue?vue&type=script&lang=js&"
export * from "./pos_sync_feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076136b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076136b4')) {
      api.createRecord('076136b4', component.options)
    } else {
      api.reload('076136b4', component.options)
    }
    module.hot.accept("./pos_sync_feed.vue?vue&type=template&id=076136b4&scoped=true&", function () {
      api.rerender('076136b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_sync/pos_sync_feed.vue"
export default component.exports